// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"86":"06652041","625":"22adb124"}[chunkId] + ".chunk.js";
};